import SERVICES from 'app-constants/service.names';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super(SERVICES.SEARCH);
  }

  getBillInfo = (payload) =>
    this.client.post(`${SERVICES.SEARCH}/bill-info`, payload);
  getOrderInfo = (payload) =>
    this.client.post(`${SERVICES.SEARCH}/order-info`, payload);
  getTrack = (payload) =>
    this.client.post(`${SERVICES.SEARCH}/get-track`, payload);
  batchQuery = (payload) =>
    this.client.post(`${SERVICES.SEARCH}/batch-query`, payload);
}

export default new Service();
